import React from 'react'
import {connect} from 'react-redux'
import {NavLink,withRouter} from 'react-router-dom'
import DataLoader from '../data/DataLoader'

class MainMenu extends React.Component {

  constructor(){
    super();

    this.state={
      open:false
    }

    this.openCloseMenu = this.openCloseMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
  }

  openCloseMenu(){
    (this.state.open)?
      this.setState({open:false})
      :
      this.setState({open:true})
  }

  closeMenu(){
      this.setState({open:false})
  }

  render () {
    //console.log(this.state.open);


    let menuItems = (this.props.optionsData)? this.props.optionsData.data.main_menu : []
    let menuExternalItems = (this.props.optionsData)? this.props.optionsData.data.main_menu_external : []

    let openClosedClass = (this.state.open)? 'open' : 'closed'


    //console.log(window.location);

    //console.log("Menu",this.props);

    let isHomepageClass =(window.location.pathname==='/')? 'on-landing-page' : ''

    return (
        <DataLoader load='menu'>
          <nav className={"main-menu "+isHomepageClass}>
            <div className={openClosedClass}>


            <div className="inner">
              <div className="top-menu">
            {
              menuItems.map((item,index)=>{

                  return (<NavLink onClick={this.closeMenu} className="menu-item" key={'m'+index} to={item.link}>{item.label}</NavLink>)

              })
            }
            </div>

            {(menuExternalItems.length)?
              <div className="other-title">Other Fyzz websites</div>
              : null
            }

              {(menuExternalItems.length)?
                menuExternalItems.map((item,index)=>{

                    return (<a onClick={this.closeMenu} className="menu-item" key={'m'+index} href={item.link} target="_blank">{item.label}</a>)

                })
                : null
              }

          </div>


          <div className="hamburger" onClick={this.openCloseMenu}>
              <div className="top" />
              <div className="middle" />
              <div className="bottom" />
          </div>


          </div>



        </nav>
        <div className={"menu-"+openClosedClass} onClick={this.closeMenu}>
          {this.props.children}
        </div>
        </DataLoader>
    )

  }
}

const mapStateToProps = (state) => {
    const optionsData = state.optionsData

    return{
      optionsData
    }
}

export default withRouter(connect(mapStateToProps)(MainMenu))



// WEBPACK FOOTER //
// ./src/modules/menu/MainMenu.js